import { gql } from '@apollo/client';

export const GET_CONFIGURATION = gql`
    query getConfiguration {
        getConfiguration {
            quizes {
                gender {
                    common
                    man
                    woman
                }
                personal {
                    common
                    man
                    woman
                }
                styleRequest {
                    common
                    man
                    woman
                }
                myPhoto {
                    common
                }
            }
            payment {
                taxPercentage
                currency
            }
            stockCheck {
                availableThreshold
                unAvailableThreshold
            }
            termsOfServices {
                stylistManualDocs
            }
            invoice {
                phone
                vatNumber
                sellerName
                arabicSellerName
            }
            stitcher {
                dynamicLayoutVersion
                objectDetectCategories
            }
            storeConfig {
                defaultWidgetButtonImageUrl
                defaultWidgetButtonText
            }
            reviewersWithSimpleFlow {
                users
            }
        }
    }
`;
